import { memo } from "react";
import { AlertOctagon, CheckCircle2, Loader2 } from "lucide-react";

type Props = {
  count: number;
  loading?: boolean;
  onOpen?: () => void;
};

/** Verdict cell for one AML matrix column using the summary count from get-aml. */
export const ScreeningCountCell = memo(function ScreeningCountCell({
  count,
  loading,
  onOpen,
}: Props) {
  if (loading) {
    return (
      <span className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="size-4 animate-spin" /> Loading…
      </span>
    );
  }

  if (count <= 0) {
    return (
      <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
        <CheckCircle2 className="size-4 text-green-600" /> No Match
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex w-full items-center gap-1.5 rounded-md bg-red-50 px-2 py-1 text-sm font-medium text-red-700 hover:bg-red-100"
      aria-label={`View ${count} AML matches`}
    >
      <AlertOctagon className="size-4" /> {count} {count === 1 ? "Match" : "Matches"}
    </button>
  );
});
